import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Text from '../Text'

const Timer = ({
    initialValue,
    onEnd,
    ...rest
}) => {

    const [seconds, setSeconds] = useState(initialValue)
    const [intervalId, setIntervalId] = useState()

    useEffect(() => {
        const interval = setInterval(() => {
            setSeconds((seconds) => seconds - 1)
        }, 1000)

        setIntervalId(interval)

        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        if (seconds > 0) return
        if (intervalId) clearInterval(intervalId)
        onEnd()
    }, [seconds])

    return (
        <Text
            {...rest}
        >
            {seconds}
        </Text>
    )
}

Timer.propTypes = {
    initialValue: PropTypes.number,
    onEnd: PropTypes.func,
}

Timer.defaultProps = {
    initialValue: 5,
    onEnd: () => { },
}

export default Timer
